export default [
  {
    children: `
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <ul class="list">
          <li>You’re here to do something big.</li>
          <li>To unleash your superpowers.</li>
          <li>To solve tough problems.</li>
          <li>To delight the pants off people.</li>
          <li>To push yourself.</li>
          <li>To be the best.</li>
          <li>To do amazing shit.</li>
          <li>To be great.</li>
        </ul>
      </div>
    `,
    layout: 5,
  },
  {
    layout: 2,
    header: "Our Purpose",
    title: "We're building the world's best game platform company.",
    paragraph:
      "We strive to create a truly great, successful and enduring company that leads our industry in both product and business quality across today’s and tomorrow’s mobile devices.",
  },
  {
    layout: 1,
    title: "Our work is a product of our culture.",
  },
  {
    layout: 2,
    header: "Our Values",
    title:
      "So, if we get the culture right, all the other stuff — passionate employees, engaged customers, a strong brand, and amazing product experiences will follow.",
    paragraph: "",
    image: require("../images/illustration-pipes.svg")?.default,
  },
  {
    layout: 1,
    title:
      "We define our culture through our values, our people, and the practices we follow.",
  },
  {
    layout: 4,
    theme: "orange",
    header: "Values",
    image: require("../images/illustration-cubes.svg")?.default,
    footer: "",
  },
  {
    layout: 6,
    header: "Our Values",
    title: "Our values aren’t just a list of beliefs.",
    paragraph:
      "They guide everything we do — our business decisions, and our interactions with our customers, our business partners and each other.",
    image: require("../images/illustration-circles.svg")?.default,
  },
  {
    layout: 6,
    header: "Our Values",
    paragraph:
      "As we grow, our strategies may shift, but our values will always stay the same.",
    paragraph_2:
      "They — along with our people and our practices — are the foundation for what we want to accomplish and who we want to become.",
    paragraph_3: "There's nothing more important.",
    image: require("../images/blank.png")?.default,
  },
  {
    layout: 5,
    children: `
      <h6 class="header">Our Values</h6>
      <h1>Greatness</h1>
      <h1>Delight</h1>
      <h1>Ownership</h1>
      <h1>Dialogue</h1>
      <h1>Action</h1>
    `,
  },
  {
    layout: 4,
    theme: "dark",
    header: "Our Values",
    image: require("../images/illustration-greatness.svg")?.default,
    footer: "We measure against the highest absolute standard.",
  },
  {
    layout: 6,
    header: "Our Values |",
    header_span: " Greatness",
    paragraph:
      "We believe in greatness. That requires setting the highest absolute standards for our work, for our partners, for the people we hire and for ourselves.",
    paragraph_2: "We are passionate about our work and strive to be the best.",
    paragraph_3:
      "We recognize greatness and reaching the highest standard is a difficult and worthwhile journey that requires hard work and resilience.",
    paragraph_4:
      "We are self-motivated, passionate about our work, and strive to be the best.",
  },
  {
    layout: 4,
    theme: "orange",
    header: "Our Values",
    image: require("../images/illustration-delight.svg")?.default,
    footer: "We exceed customer expectations.",
  },
  {
    layout: 6,
    header: "Our Values |",
    header_span: " Delight",
    paragraph:
      "We're obsessive about understanding our customers' expectations and delighting them in a way that's even better than they could have possibly imagined.",
  },
  {
    layout: 4,
    header: "Our Values",
    image: require("../images/illustration-ownership.svg")?.default,
    footer: "We take responsibility.",
  },
  {
    layout: 6,
    header: "Our Values |",
    header_span: " Ownership",
    paragraph:
      "We’re all working toward the same goals. Although it’s important to take individual ownership and be explicit about the problems you’re trying to solve. You don’t have to ask for permission. In fact, we’d prefer if you didn’t.",
    paragraph_2: "Take responsibility. It’s yours.",
  },
  {
    layout: 4,
    theme: "dark",
    header: "Our Values",
    image: require("../images/illustration-dialogue.svg")?.default,
    footer: "We listen (no, really) and speak up.",
  },
  {
    layout: 6,
    header: "Our Values |",
    header_span: " Dialogue",

    paragraph:
      'We listen. We speak up. We provide context for our ideas. We say “yes if” instead of “no because". We ask clarifying questions, rather than make assumptions. And because we respect one another, we’re never jerks about it.',
    paragraph_2: "We’re always open-minded and eager to learn.",
  },
  {
    layout: 4,
    theme: "orange",
    header: "Our Values",
    image: require("../images/illustration-action.svg")?.default,
    footer: "We focus on the inflective.",
  },
  {
    layout: 6,
    header: "Our Values |",
    header_span: " Action",
    paragraph: "Focus on the inflective.",
    paragraph_2: "Operate with a thorough and thoughtful intensity.",
    paragraph_3: "Never confuse movement with action.",
    paragraph_4: "Do. It. Now.",
  },
  {
    layout: 4,
    theme: "orange",
    header: "People",
    image: require("../images/illustration-people.svg")?.default,
    footer: "",
  },
  {
    layout: 6,
    header: "Our People",
    paragraph:
      "Our ability to achieve greatness depends on the people we have and who we hire. These are the traits we’re looking for in every N3TWORKer...",
  },
  {
    layout: 5,
    children: `
      <h6 class="header">Our People</h6>
      <h1>Make Others Better</h1>
      <h1>See and Act on Inflections</h1>
      <h1>Intrinsically Motivated & Want to Win</h1>
      <h1>Capable of Winning</h1>
      <h1>Curious & Tenacious</h1>
      <h1>Good</h1>
    `,
  },
  {
    layout: 3,
    header: "Our People",
    title: "Make Others Better",
    paragraph:
      "N3TWORKers force multiply their teammates with superior communication, decision making, leadership, work ethic, output, and impact.",
    image: require("../images/illustration-standards.svg")?.default,
  },
  {
    layout: 3,
    header: "Our People",
    title: "See and Act on Inflections",
    paragraph:
      "Anticipate problems and opportunities for inflections, before they arise. Proactive beats reactive.",
    image: require("../images/illustration-mountains.svg")?.default,
  },
  {
    layout: 3,
    header: "Our People",
    title: "Intrinsically Motivated & Want to Win",
    paragraph: `We attack our work in a way that inspires others, with a passion that comes from personally caring about what we do.`,
    image: require("../images/illustration-lines.svg")?.default,
  },
  {
    layout: 3,
    header: "Our People",
    title: "Capable of Winning",
    paragraph:
      "N3TWORKers are going to succeed. We have the inherent capability and are wired for it.",
    image: require("../images/illustration-dots.svg")?.default,
  },
  {
    layout: 3,
    header: "Our People",
    title: "Curious & Tenacious",
    paragraph:
      "N3TWORKers are open-minded, curious, and committed to continuous learning. We don’t know everything, but we’d sure like to. When faced with challenges or problems, we work persistently and relentlessly until they’re solved. We then turn our focus to the next set of challenges.",
    image: require("../images/illustration-eyes.svg")?.default,
  },
  {
    layout: 3,
    header: "Our People",
    title: "Good",
    paragraph:
      "N3TWORK hires people who are fundamentally good. The kind of people you want on your team. People who are well-respected, and who respect others. We care about our community and the world, and our impact in it.",
    image: require("../images/illustration-good.svg")?.default,
  },
  {
    layout: 4,
    theme: "orange",
    header: "Our Practices",
    image: require("../images/illustration-practices.svg")?.default,
    footer: "",
  },
  {
    layout: 2,
    header: "Our Practices",
    title:
      "Our practices are a vital part of who we are, and what we do collectively, and individually every day.",
    paragraph: "",
  },
  {
    children: `
      <h6 class="header">Our Practices</h6>
      <h1>Set Clear Expectations and Context</h1>
      <h1>Autonomy</h1>
      <h1>Personal Development & Self Improvement</h1>
    `,
    layout: 5,
  },
  {
    layout: 2,
    header: "Our Practices",
    title: `Set Clear Expectations and Context`,
    paragraph: `Setting clear expectations establishes both the baseline context for the problem being solved, and the parameters for successful outcomes. It fosters direct and honest conversations about standards, customer expectations, timeframe, priorities, and ownership. A well understood context unlocks everyone's contributions and improves the speed at which we reach our goals.`,
    paragraph_2: `As importantly, dialogue around expectations will reveal any gaps that may exist which prevent us from reaching the desired outcomes.`,
    paragraph_3: `Strive for constant two-way communication. Don't wait for a meeting or for someone to tell you. Expectations can change, so we're all responsible for ensuring we are aligned as individuals and teams.`,
    image: require("../images/illustration-connected-circles.svg")?.default,
  },
  {
    layout: 2,
    header: "Our Practices",
    title: "Autonomy",
    paragraph: `Act with entrepreneurial spirit. Decide where, when, and how you will make the largest impact on our business. You are in command of your impact, career, and destiny. Focus and adapt to changing problems that need solving, versus solely on a static area of responsibility.`,
    image: require("../images/illustration-line-circles.svg")?.default,
  },
  {
    layout: 2,
    header: "Our Practices",
    title: "Personal Development & Self Improvement",
    paragraph:
      "You’re empowered and expected to develop and improve yourself over time to reach your ultimate potential. It is your responsibility to define that journey and the steps along the way, but you’re not on your own.",
    paragraph_2:
      "Work with your discipline leader and project leader to counsel, challenge, and support you. Actively seek critical feedback from these leaders as well as your teammates as the basis for self improvement, and to reach higher performance levels. Strive for a daily and weekly feedback cadence, not quarterly, or annually.",
    paragraph_3:
      "Be thoughtful and constructive when others ask for your feedback.",
    image: require("../images/illustration-speech.svg")?.default,
  },
  {
    layout: 4,
    theme: "dark",
    header: "Tools",
    image: require("../images/illustration-tools.svg")?.default,
    footer: "",
  },
  {
    layout: 2,
    header: "Tools",
    title:
      "These are some commonly used tools we use to frame and solve problems. The toolbox is open source — please feel free to improve our tools and contribute new ones.",
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>The Periodic Table as a Metaphor for Org. Design</h2>
        <p>By modeling the periodic table and how elements (you) can have individual value and, in combination form compounds (interdisciplinary teams) we have a way of thinking about our own organizational structure.</p>
        <img alt="" src="${
          require("../images/illustration-periodic-table.svg")?.default
        }" class="img-max-width img-center"/>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
      <p>This method respects the impact of individuals, but also acknowledges the need for teams and some operating structure as we scale.</p>
      <p>Every N3TWORKer can be thought of as a unique and essential Element.</p>
      <img alt="" src="${
        require("../images/illustration-periodic-elements.svg")?.default
      }" class="img-max-width img-center"/>
        <p>In combination, our elements come together to form "compounds" that work together to advance the company by making things and solving problems.</p>
        <img alt="" src="${
          require("../images/illustration-periodic-compound.svg")?.default
        }" class="img-max-width img-center"/>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
      
      <div class="row">
        <div class="col-xs-12 col-sm-8 no-padding text">
          <p>Every element is essential and it is not necessary to have a hierarchy within the compound.</p>
          <p>Every person is essential and it is not necessary to have hierarchy within the team.</p>
        </div>

      </div>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
    
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>N3TWORK Operating System</h2>
        <p>The N3TWORK Operating System (N3TOS) keeps our objectives at the very center of our conversations and actions.</p> 
        <img alt="" src="${
          require("../images/illustration-operating-system.svg")?.default
        }" class="img-max-width img-center"/>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
    
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>N3TOS</h2>
        <p>N3TOS is comprised of three elements which work together:</p> 
        <ul>
          <li>Business – OKRs</li>
          <li>Products – Product Lifecycle Management System</li>
          <li>People – Coaching and Development Systems for N3TWORKers</li>
        </ul>
        <p>We use N3TOS to connect the dots between our business, products, and people to drive towards the desired key results.</p>
        <p>N3TOS is not the why or the what, but it is part of the how.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
    
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>A Word on OKRs</h2>
        <p>OKRs, Objectives and Key Results, are a simple tool that helps an organisation achieve goals by building specific and measurable actions as well as transparently communicating and monitoring progress toward them.</p> 
        <p>We organize all our work with OKRs.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="image">
      <img alt="" src="${
        require("../images/illustration-connected-circles.svg")?.default
      }" class="full-cover full-cover-opacity"/>
      </div>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>Goals and Ideas</h2>
        <p>Our success is measured by hitting clear objectives. We regularly define broad and inflective goals that we want to achieve within a certain time-frame.</p>
        <p>Once our goals are defined, we’re each responsible for owning, generating and executing specific ideas that support those goals.</p>
        <p class="bold">Example Goal:</p> 
        <ul>
          <li>Build a game where users play 6 sessions a day.</li>
        </ul>
        <p class="bold">Ideas to Support the Goal:</p>
        <ul>
          <li>Build connected loops that take 5 minutes to play.</li>
          <li>Develop an analytics framework that captures and measures customers’ usage patterns.</li>
        </ul>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>Greatness and Delight Planning</h2>
        <p>As you set goals, always plan for Greatness and Delight.</p>
        <p class="bold">Greatness Planning</p>
        <p>What does “state of the art” look like?</p>
        <p>To advance it, I’m going to:</p>
        <img alt="" src="${
          require("../images/illustration-planning-diagram.svg")?.default
        }" class="img-max-width"/>
        <p class="bold">Delight Planning</p>
        <p>Who are my customers?</p>
        <p>What are are my customers expectations?</p>
        <p>How do I exceed them?</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>We Become What We Measure</h2>
        <p>How do we judge success?</p>
        <ul>
          <li>
            <p class="bold">Understand what to measure and choose the right metrics for success.<br>Always ask:</p>
            <p>What does success look like?</p>
            <p>What are the measures of success?</p>
          </li>
          <li>
            <p class="bold">Frame the conversation around goals. Express the following:</p>
            <p>This [insert goal or idea] will be successful if [these criteria are met].</p>
            <p>That success will be measured by these KPIs [determine KPIs].</p>
            <p>Orient future actions and iterations around those KPIs.</p>
          </li>
        </ul>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>Failure</h2>
        <p>Failure is a tool that keeps us sharp. Failure is a milestone on the pathway to success. Embrace, and learn from failures.</p>
        <p>Try not to repeat them :)</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h4>“I’ve missed more than 900 shots in my career. I’ve lost almost 300 games. 26 times, I’ve been trusted to take the game winning shot and missed. I’ve failed over and over and over again in my life. And that is why I succeed.”</h4>
        <p>– Michael Jordan</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>Capture and Share Knowledge</h2>
        <p>Insights, learning, and knowledge are created every day during the course of your work.</p>
        <p>To make the most of them, we:</p>
        <ul>
          <li>Capture and share these insights as they happen to promote learning and knowledge sharing.</li>
          <li>Share key product, business, design, and engineering insights on Notion.</li>
          <li>Document and share larger designs in Google Docs.</li>
        </ul>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>Refine Ideas in Public</h2>
        <p>To have the most productive conversations, be candid about the state of your idea.</p>
        <p>Tag your ideas “Work in Progress” to:</p>
        <ul>
          <li>Give team members permission to offer feedback and spark dialogue.</li>
          <li>Iterate much faster than by working alone.</li>
          <li>Encourage conversations framed by “Yes, if...” rather than “No, because...”</li>
        </ul>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-8 no-padding text">
        <h2>Have Important Conversations (HIC)</h2>
        <p>Tips for sucessful dialogue:</p>
        <ul>
          <li>Be thoughful and open-minded in your approach</li>
          <li>Clearly state your goal and intention for the conversation</li>
          <li>Take ownership</li> 
          <li>Share your experience and invite other perceptions</li> 
          <li>Actively listen and paraphrase what you think you heard</li>
          <li>Co-create a solution</li>
        </ul>
        <br>
        <br>
        <p>If all else fails, just be present and listen, or know when to table the conversation till a later date. This can be one of a few conversations.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>State Your Heading</h2>
        <p>To get everyone on the same page, state the obvious:</p>
        <ul>
          <li>
            <p>“I am trying to accomplish [insert objective].”</p>
          </li>
          <li>
            <p>“This meeting will be successful if [insert objective].”</p>
          </li>
        </ul>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>ABC 123</h2>
        <p>ABC 123 is a tool to simplify your objectives into a core set of critical actions to take. It also helps find inflection opportunities and traps.</p>
        <div class="row">
          <div class="col-xs-6 abc-123">
            <h6 class="header">ABC</h6>
            <img alt="" src="${
              require("../images/illustration-priority-a.svg")?.default
            }" class=""/>
            <p>ABC is a customer lens</p>
          </div>
          <div class="col-xs-6 abc-123">
            <h6 class="header">123</h6>
            <img alt="" src="${
              require("../images/illustration-priority-1.svg")?.default
            }" class=""/>
            <p>123 is a priority and sequencing lens</p>
          </div>
        </div>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Triangles</h2>
        <p>Define the problem area.
        Then define three things that clarify the problem you’re trying to solve (1,2,3).</p>
        <p>Can you solve the problem within these boundaries? If not, then define three things that more narrowly define the problem (1.1, 2.1, 3.1)</p>
        <p>Iterate on all three sides until you can solve the problem.</p>
        <img alt="" src="${
          require("../images/illustration-triangles.svg")?.default
        }" class="img-max-width"/>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Invention Funnel</h2>
        <p>A tool to manage risk during rapid iteration</p>
        <img alt="" src="${
          require("../images/illustration-invention-funnel.svg")?.default
        }" class="img-max-width"/>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Maps</h2>
        <p>A visual representation of a solution or action plan</p>
        <p>Use a map to visually describe a unique system, execution, or problem.</p>
        <p>Connect discrete areas of the map to illustrate information flow, movement, or activity between disconnected areas.</p>
        <img alt="" src="${
          require("../images/illustration-map.svg")?.default
        }" class="img-max-width"/>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Tools</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Engagement Loop</h2>
        <p>A simple loop of connected activities to articulate a process.</p>
        <ul>
          <li>Create a loop to design engagement across a range of users (i.e. consumers, employees, partners).</li>
          <li>Loops should always connect. Dead-ends need to be resolved.</li>
        </ul>
        <img alt="" src="${
          require("../images/illustration-engagement-loop.svg")?.default
        }" class="img-max-width"/>
      </div>
    `,
  },
  {
    layout: 4,
    theme: "orange",
    header: "Behaviors",
    image: require("../images/illustration-behaviors.svg")?.default,
    footer: "",
  },
  {
    layout: 2,
    header: "Behaviors",
    title:
      "Along with our values, these behaviors we expect from one another, as teammates.",
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Behaviors</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Own Your Schedule</h2>
        <p>Take charge of your time:</p>
        <ul>
          <li>Determine how, when, and where you are most productive.</li>
          <li>Communicate your needs with your teammates.</li>
          <li>Accommodate your teammates’ needs.</li>
          <li>Take vacation when you need or want to recharge. </li>
        </ul> 
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Behaviors</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Take Responsibility</h2>
        <p>Every N3TWORKer is required to know — or discover — how they work best.</p>
        <p>We are each responsible for our own productivity.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Behaviors</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Give Respect</h2>
        <p>We respect one another. Our ideas. Our time. Our different ways of working. A good question to ask is, “How do you work best?” We’re a team, even if we’re working alone on or an individual project.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Behaviors</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Seek Context</h2>
        <p>It’s important to understand the context of your work, and of the problem you’re solving. Avoid making assumptions, and ask clarifying questions whenever you need to.</p>
        <p>We’re all happy to answer.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Behaviors</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Simplify</h2>
        <p>We strive to make the complex simple. Simplifying means prioritizing and using visual tools to clarify our plans.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Behaviors</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Embrace Change</h2>
        <p>Change is a catalyst for growth and development. It pushes you and makes you better. We embrace change. In fact, one of our favorite questions is, “What’s next?”</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Behaviors</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Seek Leadership Opportunities</h2>
        <p>N3TWORK is a leader in our industry. Show leadership and expertise by contributing to professional communities, speaking at conferences, writing articles, committing code to open source projects, and serving on boards. Leadership opportunities force us into the good habit of organizing and articulating our thoughts and actions for the public.</p>
      </div>
    `,
  },
  {
    layout: 4,
    theme: "orange",
    header: "Policies",
    image: require("../images/illustration-policies.svg")?.default,
    footer: "",
  },
  {
    layout: 2,
    header: "Policies",
    title: "These are important principles of action we want to highlight.",
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Policies</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Hire Only the Best</h2>
        <p>Our success depends on hiring the very best people. When we interview, we’re not just looking for the right experience. We’re looking for people who share our values. That means:</p>
        <ul>
          <li>We’re purposeful interviewers.</li>
              <ul>
                <li>We’re on time.</li>
                <li>We’re prepared.</li>
                <li>We’re coordinated.</li>
              </ul>
          </li>
          <li>We enthusiastically and expertly represent the company, culture, vision, and strategy to prospective N3TWORKers.</li>
          <li>Each candidate interviews with one founder.</li>
        </ul>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Policies</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>From Candidates to N3TWORKers</h2>
        <p>We view every candidate as a potential employee. Everything from the first interaction to the first day is carefully crafted to ensure candidates either exit the process feeling amazed at what we do (and wishing they worked here) or become an employee who joins us motivated to succeed.</p>
        <ul>
          <li>Actively engage candidates every step of the way</li>
          <li>Meaningful moments during the interview process</li>
          <li>The on-boarding experience is designed to prepare new employees to make an impact. It should exceed all expectations and reinforce their decision to join N3TWORK</li> 
          <li>On-boarding coach</li>
        </ul>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Policies</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Always Have a Coach</h2>
        <p>Coaching helps us become the best at what we do. When you join, you’ll be assigned one. As your needs and goals evolve, you may have more. The important thing is that you’re learning from one another.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Policies</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Be a Coach</h2>
        <p>Coaching at N3TWORK goes both ways. Instead of a traditional hierarchical structure, where managers coach their reports, we organize horizontally. Coaches are not bosses. A coach is available as a sounding board, to listen and be honest. Coaches with valuable experience are required to share that knowledge to help others solve problems and reach their full potential. Coaches benefit too, as the experience allows them to see things from a new perspective. In this structure, everyone is required to both give and seek feedback.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Policies</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>No Titles</h2>
        <p>We don’t believe in titles. We believe in making an impact — without constraints — and working toward our goals. So regardless of your experience or background, you’re empowered and licensed to build a great company.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Policies</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Meetings</h2>
        <p>We believe meetings are best kept to a minimum. This is how we do it:</p>
        <ul>
          <li>We strive to have very few recurring meetings.</li>
          <li>All meetings have a purpose. Always state what type:</li>
          <ul>
            <li>Coaching</li>
            <li>Alignment</li>
            <li>Ask and answer</li>	<li>Solve a problem</li>
            <li>Inspirational</li>
            <li>Nommunication (informal gatherings around drinks or food)</li>
          </ul>
          <li>The meeting organizer sends agenda beforehand.</li>
          <li>Be flexible and considerate of others’ schedules.</li>
        </ul>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Policies</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>Take The Lead</h2>
        <p>Leads are expected to handle input and output, the coordination of work, and communicate inside and outside the team. The lead is the point person until the work is finished and the goal is accomplished. Want to take the reins? Volunteer. We choose our project leads by consensus.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <h6 class="header">Policies</h6>
      <div class="col-xs-12 col-sm-10 col-lg-6 no-padding text">
        <h2>N3TWORKed Life</h2>
        <p>We want N3TWORKers to do the best work of their lives in a distributed and flexible environment. To support this, we offer practical reimbursement for things like internet and phone bills, and workspace equipment. In addition, we offer reimbursement for services related to physical and mental health as well as once per month house cleaning so that we can help you recapture time for the things that make you happy outside of work and you can focus on recharging.</p>
      </div>
    `,
  },
  {
    layout: 5,
    theme: "dark",
    children: `
      <div class="col-xs-12 no-padding text">
        <img alt="" src="${
          require("../images/illustration-end.svg")?.default
        }" class="img-max-width img-center"/>
      </div>
  `,
  },
]
